import axios from 'axios'
import {EntityDto} from '../../../../../../../services/dto/entityDto'
import {PagedResultDto} from '../../../../../../../services/dto/pagedResultDto'
import {PagedGraduatedWorkInfoResultRequestDto} from './dto/PagedGraduatedWorkInfoResultRequestDto'
import CreateGraduatedWorkInfo from './dto/CreateGraduatedWorkInfo'
import GetAllGraduatedWorkInfos from './dto/GetAllGraduatedWorkInfos'
import UpdateGraduatedWorkInfo from './dto/UpdateGraduatedWorkInfo'
import GetGraduatedWorkInfo from './dto/GetGraduatedWorkInfo'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/GraduatedWorkInfo/Create`
export const URL_DELETE = `${API_URL}/GraduatedWorkInfo/Delete`
export const URL_GET = `${API_URL}/GraduatedWorkInfo/Get`
export const URL_GET_BY_GRADUATED_ID = `${API_URL}/GraduatedWorkInfo/GetByGraduatedId`
export const URL_UPDATE = `${API_URL}/GraduatedWorkInfo/Update`

export function onCreateGraduatedWorkInfo(
  createGraduatedWorkInfo: CreateGraduatedWorkInfo
): Promise<boolean> {
  return axios.post(URL_CREATE, createGraduatedWorkInfo)
}

export function onDeleteGraduatedWorkInfo(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetGraduatedWorkInfo(entityDto: EntityDto): Promise<GetGraduatedWorkInfo> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetGraduatedWorkInfoByGraduatedId(
  graduated: EntityDto
): Promise<GetAllGraduatedWorkInfos> {
  return axios.get(URL_GET_BY_GRADUATED_ID, {params: graduated})
}

export function onUpdateGraduatedWorkInfo(
  updateGraduatedWorkInfoInput: UpdateGraduatedWorkInfo
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateGraduatedWorkInfoInput)
}
